import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import { AppRoutes } from '@/app/routes';
import OnlineTimeTrackingWithCondition from '@/app/lib/onlineTimeTracking/onlineTimeTrackingWithCondition';
import { NotFound } from '@/pages/not-found';
import useMain from './useMain';
import './style.scss';

momentDurationFormatSetup(moment);

/**
 * Renders the application shell once authentication has passed. Swaps in the not-found page when useMain reports the page crashed, otherwise mounts the conditional online-time tracker alongside the route table.
 *
 * @returns The rendered app shell, or the not-found page when the page has crashed.
 */
const Main = () => {
  const { isPageCrashed } = useMain();

  if (isPageCrashed) return <NotFound />;

  return (
    <div className="app">
      <OnlineTimeTrackingWithCondition />
      <AppRoutes />
    </div>
  );
};

export default Main;
